import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,ViewEntity, ViewColumn} from "typeorm";
import {appSettings} from '../../../../config';
@ViewEntity({ 
  expression: `SELECT z.zone_id as zoneId,z.zone_code AS zoneCode,r.rack_id as rackId,r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,so.po_number AS poNumber,b.brand_name as brandName,CONCAT(s.min_grade,'-',s.max_grade) AS grade,p.name AS productName,sc.variant_code as variantCode,s.pallet_code AS palletCode,s.packing_completed AS packingCompleted,s.state AS stockState,s.stock_type AS stockType,r.plant_id AS unitId FROM `+appSettings.masters_db+`.rack_position r 
  LEFT JOIN `+appSettings.warehouse_db+`.stock s ON s.location= r.rack_position_id
  LEFT JOIN `+appSettings.masters_db+`.zone_master z ON z.zone_id=r.zone_id
  LEFT JOIN `+appSettings.sales_db+`.so_invoice_details so ON so.sale_order_id=s.sale_order_id
  LEFT JOIN `+appSettings.masters_db+`.brands b ON b.brand_id=s.brand_id
  LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id=s.product_id
  LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id=s.varient_id order by r.rack_code`
})
export class WarehouseView {
  @ViewColumn()zoneId:number;
  @ViewColumn()rackId:number;
  @ViewColumn()zoneCode: string;
  @ViewColumn()rackPositionId: number;
  @ViewColumn()rackCode: string;
  @ViewColumn()occupancy:string;
  @ViewColumn()poNumber:string;
  @ViewColumn()brandName: string;
  @ViewColumn()grade: string;  
  @ViewColumn()productName: number;
  @ViewColumn()variantCode: string;
  @ViewColumn()palletCode: string;  
  @ViewColumn()packingCompleted:string;
  @ViewColumn()stockState:string;
  @ViewColumn()stockType:string;
  @ViewColumn()unitId:number;
  // @ViewColumn()
  // productName:string;
  // @ViewColumn()
  // variantCode:string;
  // @ViewColumn()
  // minGrade:string;
  // @ViewColumn()
  // maxGrade:string;
  // @ViewColumn()
  // stockState:string;
  // @ViewColumn()
  // grade:string;

}